<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import {ref, defineExpose, onMounted} from "vue";
import { useRouter } from 'vue-router'
import mypageProposalService from "../../../services/mypage/mypageProposalService";
import Loading from 'vue3-loading-overlay';
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairUserService from "../../../services/jobFair/jobFairUserService";
import jobFairCorpService from "../../../services/jobFair/jobFairCorpService";
import JobFairJobNoticeModalBody from "./JobFairJobNoticeModalBody.vue";
import JobFairResumeListModal from "@/pages/user/components/modal/jobFair/JobFairResumeListModal.vue";
import JobFairApplyResumeConfirmModal from "@/pages/user/components/modal/jobFair/JobFairApplyResumeConfirmModal.vue";
import JobFairApplyResumeModal from "@/pages/user/components/modal/jobFair/JobFairApplyResumeModal.vue";
import { useAlertStore } from "../../../../../stores/alertStore";
const { $alert, $confirm} = useAlertStore();

const router = useRouter();
const loadingStore = usePageLoadingStore()

const baseModal = ref(null);
const resolvePromise = ref(null);
const resumeListModal = ref(null); // 이력서 보기
const applyResumeConfirmModal = ref(null); // 회사 이력서 안내
const applyResumeModal = ref(null); // 회사 이력서 입사지원

const modalBody = ref(null)
const loaded = ref(false)

const showButtons = ref(false);
const showPropsButtons = ref(false);
const showInteButtons = ref(false);
const noticeLikeTxts = ref("♡관심공고");
const resumeIds = ref(0)
const applicantCnts = ref(0);
const joinStateGbs = ref(0);
const ojfIds = ref(0)
const jobNoticeSeqs = ref(0);
const inteYns = ref(false); // 관심공고 여부
const userCorpMasterYns = ref(false); // 기업 마스터 유무
const corpIds = ref(0);
const completeInteYns = ref(false);
const modes = ref(''); // mypage


let fileYns = ref("");
let apllyYns = ref("");
let applyStateBtn = ref("");

// 채용공고 보기
const ojfCropJobNoticeDetail = (jobNoticeSeq) => {
  jobNoticeSeqs.value = jobNoticeSeq;
  loaded.value = false;

  if(jobNoticeSeq) {
    let paramObj = {
      jobNoticeSeq: jobNoticeSeq,
    }
    jobFairCorpService.ojfCropJobNoticeDetail(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setJobNotice(result);
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  }
}

// 특별채용관 참가 정보
const ojfCorpRecruitmentHall = (ojfId, corpId) => {
  loaded.value = false;
  corpIds.value = corpId;

  let paramObj = {
    ojfId: ojfId,
    corpId: corpId,
  }

  jobFairCorpService.ojfCorpRecruitmentHall(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          modalBody.value.setRecruitmentHall(result);
          fileYns.value = result.fileYn;
          joinStateGbs.value = result.joinStateGb;
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 기업 정보
const ojfCorporationDetail = (corpId) => {
  loadingStore.loading = true;
  jobFairCorpService.ojfCorporationDetail(corpId)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          modalBody.value.setCorp(result, modes.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 채용공고 수정 버튼
// 페이지 복귀로 인해 두개로 분리
const onClickChangeJobNotice = (jobNoticeSeq, mode) => {
  router.push({ name: 'MyPageCorpJobNotice', query : { jobNoticeSeq: jobNoticeSeq, mode: mode } })
}
// 면접제안이 있는 채용공고 수정 버튼
const onClickChangeJobNotice2 = (jobNoticeSeq, resumeId, completeInteYn, mode) => {
  if (completeInteYn === true) {
    completeInteYn = 'Y'
  } else {
    completeInteYn = 'N'
  }
  router.push({ name: 'MyPageCorpJobNotice', query : { jobNoticeSeq: jobNoticeSeq, resumeId: resumeId, inteYn: completeInteYn, mode: mode } })
}

// 채용공고 삭제
const onClickDelete = async (jobNoticeSeq) => {
  const ok = await $confirm(["채용공고를 삭제하시겠습니까?"], "삭제");
  if(!ok) {
    return -1;
  } else {
    jobFairCorpService.ojfCropJobNoticeDelete ( jobNoticeSeq )
        .then((res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            $alert(["채용공고가 삭제되었습니다."]);
            // 팝업 닫기
            baseModal.value.close();
            resolvePromise.value(false);
          }
        }).catch( (res) =>  {
          loadingStore.loading = false;
          // console.log(res);
          $alert(res.response.data.result.message);
        });
  }
}

// 면접제안
const onClickInterviewProposal = async (ojfId, resumeId, jobNoticeSeq) => {
  const ok = await $confirm(["선택한 채용공고로", "면접제안을 하시겠습니까?"], "면접제안");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: ojfId,
      resumeId: resumeId,
      jobNoticeSeq: jobNoticeSeq,
    }

    loadingStore.loading = true;
    jobFairCorpService.ojfCropInterviewProposalCreate(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            $alert(["면접제안을 하였습니다."]);
            baseModal.value.close();
            resolvePromise.value(false);
          } else {
            $alert(["면접제안을 실패하였습니다."]);
          }
        }).catch( (error) =>  {
          loadingStore.loading = false;
          $alert(["제안을 실패하였습니다."]);
        });
  }
}

// 관심 공고 관심여부
const onClickNoticYn = async (ojfId, jobNoticeSeq, inteYn) => {
 let message, okButtonText;
  if (inteYn === 'N') {
    message = ["관심공고을 등록하시겠습니까?"];
    okButtonText = "관심공고 등록";
    inteYn = "Y"
  } else {
    message = ["관심공고을 삭제하시겠습니까?"];
    okButtonText = "관심공고 삭제";
    inteYn = "N"
  }

  const ok = await $confirm(message, okButtonText);
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: ojfId,
      jobNoticeSeq: jobNoticeSeq,
      interestNoticeYn: inteYn,
    }

    jobFairUserService.ojfInterestNoticeYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            if (inteYn === 'Y') {
              $alert(["등록하였습니다."]);
              noticeLikeTxts.value = "♥관심공고";
              inteYns.value = "Y";
            } else {
              $alert(["삭제하였습니다."]);
              noticeLikeTxts.value = "♡관심공고";
              inteYns.value = "N";
            }
          } else {
            $alert(["실패하였습니다."]);
          }
        }).catch( (res) =>  {
          loadingStore.loading = false;
          $alert(["실패하였습니다."]);
        });
  }
}

// 입사지원 - 협회 이력서
const onClickApplicant = (ojfId, jobNoticeSeq, mode) => {
  // 면접제안 확인 (0이면 제안한적 없음, 0초과면 제안이 있음)
  let paramObj = {
    ojfId: ojfId,
    jobNoticeSeq: jobNoticeSeq,
  }
  jobFairUserService.ojfUpdateApplyByUserId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          if (result.length) {
            $alert(["이미 '입사지원'이 완료된 '채용공고'입니다."]);
          } else {
            resumeListModal.value.init(result.length, mode);
            resumeListModal.value.ojfResumeListJobNoticeSeq(ojfId, jobNoticeSeq);
            await resumeListModal.value.show();
            baseModal.value.close();
            resolvePromise.value(false);
          }
        } else {
          console.log(res);
        }
      }).catch( (res) =>  {
        loadingStore.loading = false;
        console.log(res);
      });
}

// 입사지원 - 회사 이력서
const onClickCorpApplicant = (ojfId, jobNoticeSeq) => {
  // 면접제안 확인 (0이면 제안한적 없음, 0초과면 제안이 있음)
  let paramObj = {
    ojfId: ojfId,
    jobNoticeSeq: jobNoticeSeq,
  }
  jobFairUserService.ojfUpdateApplyByUserId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          apllyYns.value = result.length;
          if (result.length > 0) {
            $alert(["이미 '입사지원'이 완료된 '채용공고'입니다."]);
          } else {
            // 회사이력서 양식 안내 팝업
            const ok = await applyResumeConfirmModal.value.show();

            if(ok) {
              applyResumeModal.value.init(ojfId, jobNoticeSeq);
              applyResumeModal.value.show();

              baseModal.value.close();
              resolvePromise.value(false);
            }

          }
        } else {
          console.log(res);
        }
      }).catch( (res) =>  {
    loadingStore.loading = false;
    console.log(res);
  });
}

const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = async () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const init = (showButton, showPropsButton, showInteButton, ojfId, resumeId, inteYn, userCorpMasterYn, applicantCnt, joinStateGb, mode) => {

  // 기본값 저장
  showButtons.value = showButton;
  showPropsButtons.value = showPropsButton;
  showInteButtons.value = showInteButton; // 면접제안 버튼

  modes.value = mode; // 마이페이지, 기업공채관

  console.log(modes.value);

  // Matching > 인재정보 > 면접제안 > 채용공고
  // inteYn는 이력서 데이터로 전달 받음
  // 이력서 데이터가 있고 숫자로 들어 왔을 때 면접제안 완료한 채용공고
  if (showInteButton) {
    if (typeof inteYn === 'number') {
      // 면접 제안 불가 - 제안 완료된 채용공고
      completeInteYns.value = true;
      inteYns.value = inteYn;
      // console.log('면접제안', inteYns.value);
    } else {
      // 면접 제안 가능
      completeInteYns.value = false;
    }
  }

  apllyYns.value = ''; // 구직자 : 채용공고가 회사 이력서 일 때, 입사지원 클릭 시 결과값 초기화

  // 면접제안 데이터
  ojfIds.value = ojfId;
  resumeIds.value = resumeId; // 기업 : GNB 특별채용관 > 채용공고 -> 사용자 회사 id

  // 채용공고 관리 및 지원 현황 목록에서 데이터 받음
  // applicantCnt, joinStateGb 조건에 따라 수정 버튼 작업
  applicantCnts.value = applicantCnt;
  joinStateGbs.value = joinStateGb;

  // 이력서 관리 및 입사지원 현황 > 입사지원
  if (applicantCnt === '지원함') {
    applyStateBtn.value = 'Y';
  }

  // inteYn 데이터가 있으면 'Y'로 데이터 변경
  // 관심공고 여부
  if (inteYn && inteYn === 'Y') {
    inteYn = 'Y';
    noticeLikeTxts.value = "♥관심공고"
  } else {
    inteYn = 'N';
    noticeLikeTxts.value = "♡관심공고"
  }
  inteYns.value = inteYn;

  // Matching > 특별채용관 > 채용공고에서 조건으로 데이터 전달 받았었는데
  // 조건이 변경 된 후로 사용 안함 20250527
  userCorpMasterYns.value = userCorpMasterYn;
}

defineExpose({
  show,
  init,
  ojfCropJobNoticeDetail, // 채용공고 보기
  ojfCorpRecruitmentHall, // 특별채용관 참가 정보
  ojfCorporationDetail, // 기업 정보
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <loading
        :active="!loaded"
        loader="dots"
        color="#3843AF"
        opacity="0.5"
        width="35"
        :is-full-page="false"></loading>
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body" v-show="loaded">
        <JobFairJobNoticeModalBody ref="modalBody"/>
      </div>
      <div v-if="showButtons" class="modal-footer btn-wrap">
        <!-- 채용공고 관리 및 지원 현황과 조건 동일 -->
        <!-- 승인/반려 처리 이전(01 신청 접수 완료 02 신청 검토중) = 수정가능, 삭제 불가 -->
        <div v-if="joinStateGbs === '01' || joinStateGbs === '02'" style="margin-left: auto;">
          <KSAPrimaryButton text="수정" @click="onClickChangeJobNotice(jobNoticeSeqs, modes)"/>
        </div>
        <!-- 승인처리 이후(11) -->
        <div v-else-if="joinStateGbs === '11'" style="width: 100%; padding: 0;">
          <!-- 승인처리 이후(11) + 입사지원 없는 경우 = 수정가능, 삭제 가능 -->
          <div v-if="applicantCnts === 0" class="modal-footer btn-wrap" style="padding: 0;">
            <KSASecondaryButton text="삭제" class="red_button" @click="onClickDelete(jobNoticeSeqs)"/>
            <KSAPrimaryButton text="수정" @click="onClickChangeJobNotice(jobNoticeSeqs, modes)"/>
          </div>
          <div v-else></div>
        </div>
        <!-- 반려 처리 이후 = 수정가능(의미없음), 삭제 가능 -->
        <div v-else-if="joinStateGbs === '21'" class="modal-footer btn-wrap" style="width:100%; padding: 0;">
          <KSASecondaryButton text="삭제" class="red_button" @click="onClickDelete(jobNoticeSeqs)"/>
          <KSAPrimaryButton text="수정" @click="onClickChangeJobNotice(jobNoticeSeqs, modes)"/>
        </div>
        <div v-else></div>
      </div>
      <div v-if="showPropsButtons" class="modal-footer btn-wrap">
        <!-- 관심공고 -->
        <KSASecondaryButton :text="noticeLikeTxts" @click="onClickNoticYn(ojfIds, jobNoticeSeqs, inteYns)" class="red_button"/>
        <div v-if="applyStateBtn !== 'Y'">
          <div v-if="fileYns === 'N'">
            <!-- 협회 이력서 입사지원 -->
            <KSAPrimaryButton v-if="fileYns === 'N' || applyStateBtn !== 'Y'" text="입사지원" @click="onClickApplicant(ojfIds, jobNoticeSeqs, modes)" />
          </div>
          <div v-else>
            <!-- 회사 이력서 입사지원 -->
            <KSAPrimaryButton v-if="!apllyYns" text="입사지원" @click="onClickCorpApplicant(ojfIds, jobNoticeSeqs)" />
            <div v-else>
              <KSAPrimaryButton v-if="apllyYns > 0" text="지원완료" disabled="disabled" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="showInteButtons" class="modal-footer btn-wrap">
        <!-- 면접제안 버튼 -->
        <KSAPrimaryButton text="수정" @click="onClickChangeJobNotice2(jobNoticeSeqs, resumeIds, completeInteYns, modes)" />
        <div style="width: 100%; display: flex; justify-content: right">
          <!-- inteYn 값이 'Y'면 제안 완료-->
          <KSAPrimaryButton v-if="completeInteYns" text="제안완료" disabled="disabled" />
          <KSAPrimaryButton v-else text="선택" class="red_button" @click="onClickInterviewProposal(ojfIds, resumeIds, jobNoticeSeqs)" />
        </div>
      </div>
    </div>
  </Modal>
  <JobFairResumeListModal ref="resumeListModal" /> <!-- 이력서 목록 보기 -->
  <JobFairApplyResumeConfirmModal ref="applyResumeConfirmModal" :okButtonText="네" :cancelButtonText="아니오"/> <!-- 회사 이력서 안내 -->
  <JobFairApplyResumeModal ref="applyResumeModal" /> <!-- 회사 이력서 입사지원 -->

</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>